export enum SectionNames {
  Banner = 'banner',
  About = 'about',
  Projects = 'projects',
  Contact = 'contact',
}
